module.exports = __webpack_public_path__ + "static/images/corp-billing.1c-uxyr.svg";